import { FC, ReactNode } from 'react';
import { Card, CardContent } from '@ibsys/kit';
import { cn } from '@/shared/lib';

type Props = {
  label: ReactNode;
  value: ReactNode;
  /** true — уменьшает размер значения (для длинных строк, например названия критерия) */
  compact?: boolean;
};

/**
 * Карточка KPI: подпись сверху, крупное значение снизу.
 * Используется в верхнем ряду метрик дашборда.
 */
export const KpiCard: FC<Props> = ({ label, value, compact }) => (
  <Card>
    <CardContent className="p-4">
      <div className="text-xs text-muted-foreground mb-1">{label}</div>
      <div className={cn('font-bold', compact ? 'text-lg' : 'text-2xl')}>{value}</div>
    </CardContent>
  </Card>
);
